import { overrideQuestionModel } from '../model/override-question-model.js'
import { importedQuestionModel } from '../model/imported-question-model.js'

export let storeUtils = {
  getAllEnumsFor: function (enums, id) {
    const en = enums.find(e => e.id == id)
    return en ? [ en ] : enums.filter(e => e.parentId == id)
  },
  
  ////////////////////////////////////////////
  // Import
  ////////////////////////////////////////////

  applyValuePairs: function (enums, valuePairs, userSet) {
    userSet = !!userSet
    for (var i = 0 ; i < valuePairs.length; i++) {
      let v = valuePairs[i]
      let oq = overrideQuestionModel.questions.find(q => q.id == v[0])
      if (oq) {
        if (oq.type == 'radio') {
          let en = enums.find(e => e.id == v[0])
          let value = parseInt(v[1].substr(1))
          en.which = oq.items.findIndex(i => i.value == value)
          en.userSet = userSet
        }
        else if (oq.type == 'flags') {
          let ens = this.getAllEnumsFor(enums, oq.id)
          let flags = overrideQuestionModel.flagsIdToFlags(oq, v[1])
          for (var j = 0; j < ens.length; j++) {
            ens[j].which = flags[j]
            ens[j].userSet = userSet
          }
        }
      }
      else {
        let oq = overrideQuestionModel.questions.find(q => (q.type == 'scores') 
          && q.items.find(it => it.id == v[0]))
        if (oq && (oq.type == 'scores')) {
          let item = oq.items.find(it => it.id == v[0])
          let value = parseInt(v[1].substr(1))
          let en = enums.find(e => e.id == v[0])
          let options = overrideQuestionModel.getOptionsForQuestionItem(oq, item)
          en.which = options.findIndex(i => i.value == value - item.offset)
          en.userSet = userSet
        }
      }
    }
  },

  ////////////////////////////////////////////
  // Export
  ////////////////////////////////////////////

  exportModelPair: function(enums, includePrefix, model) {
    // console.log('exportModelPair:')
    // console.log(model)
    // For list types
    var value = null, oq, ens, item
    if (model.questionType == 'list') {
      ens = this.getAllEnumsFor(enums, model.id)
      if (ens.length == 1) {
        oq = overrideQuestionModel.questions.find(q => q.id == ens[0].id)
        if (oq) {
          // Radio
          value = ens[0].which < 0 ? -1 : oq.items[ens[0].which].value
          if (includePrefix) {
            item = model.items.find(ii => ii.value == value)
            value = item ? item.id : null
          }
        }
        else {
          // Part of scores set
          oq = overrideQuestionModel.questions.find(q => (q.type == 'scores')
            && (q.items.find(oi => oi.id == model.id)))
          let oqi = oq.items.find(oi => oi.id == model.id)
          let scores = oqi.scores ? oqi.scores : overrideQuestionModel.getOptionsForQuestion(oq)
          value = ens[0].which < 0 ? -1 : scores[ens[0].which].value + oqi.offset
          if (includePrefix) {
            item = model.items.find(ii => ii.value == value)
            value = item ? item.id : null
          }
        }
         
      }
    }
    // for flags types
    else if (model.questionType == 'flags') {
      oq = overrideQuestionModel.questions.find(q => q.id == model.id)
      ens = this.getAllEnumsFor(enums, model.id)
      var sum = 0
      ens.forEach(en => {
        if (en < 0) {
          return null
        }
        sum += en.which == 1 ? en.flagValue : 0
      })
      let iqi = model.items.find(i => i.flags == sum)
      if (iqi) {
        value = includePrefix ? iqi.id : iqi.value
      }
    }
    return value == null ? null : [model.id, value] 
  },
  
  exportValuePairs: function(enums, includePrefix) {
    let map = {}
    for (const property in importedQuestionModel) {
      if (property.startsWith('model')) {
        let model = importedQuestionModel[property]
        let pair = this.exportModelPair(enums, includePrefix, model)
        if (pair) {
          map[pair[0]] = pair[1]
        }
      }
    }
    return map
  },

  extractCompletionData: function(state) {
    return {
      caller: state.caller,
      location: state.location,
      version: state.version,
      hrcid: state.hrcid,
      source: state.source,
      questions: Object.entries(this.exportValuePairs(state.enums, true))
    }
  }
}

